import dayjs from "dayjs";
import { ObjectGeneric } from "../../utils/types/generals"
import { Constants } from "../../utils/constants";
import { BodyAddFile } from "../../pages/filesManager/pages/main/components/userFiles/types";
import { FileData } from "../../pages/filesManager/pages/detail/components/dataFile/types";


const createFileBody = ({ file, data, userPermissions, requestingUsers }: { file: File | null, data: ObjectGeneric, userPermissions: Record<string, { seeFile?: boolean; downloadFile?: boolean; }>, requestingUsers: number[] }) => {

    const formData = new FormData();

    if (file) {
        formData.append('files', file); // ← nombre esperado por el backend en req.files
    }

    const users = Object.entries(userPermissions).map(([key, value]) => ({
        id: Number(key),
        canView: value.seeFile,
        canDownload: value.downloadFile,
    }));

    if (data.from) {
        formData.append('dateStart', dayjs(data.from).format(Constants.dayjsFormat3));
    }

    if (data.to) {
        formData.append('dateEnd', dayjs(data.to).format(Constants.dayjsFormat3));
    }

    if (users.length) {
        formData.append('users', JSON.stringify(users));
    }

    if (requestingUsers.length) {
        formData.append('userRequestIds', JSON.stringify(requestingUsers));
    }

    //formData.append('users', JSON.stringify(users)); // serializa el array
    //formData.append('userRequestIds', JSON.stringify(users)); 

    return formData;
}

const updateFileBody = ({ file, data, requestingUsers }: { file: FileData | File, data: ObjectGeneric, requestingUsers: number[] }) => {

    const formData = new FormData();

    if (file instanceof File) {
        formData.append('files', file); // ← nombre esperado por el backend en req.files
    }

    if (data.from) {
        formData.append('dateStart', dayjs(data.from).format(Constants.dayjsFormat3));
    }

    if (data.to) {
        formData.append('dateEnd', dayjs(data.to).format(Constants.dayjsFormat3));
    }

    if (requestingUsers.length) {
        formData.append('userRequestIds', JSON.stringify(requestingUsers));
    }

    return formData;
}

const updatePermisisonBody = ({ userPermissions }: { userPermissions: Record<string, { seeFile?: boolean; downloadFile?: boolean; }> }) => {

    const body = Object.entries(userPermissions).map(([id, perms]) => ({
        id: Number(id),
        canView: perms.seeFile ?? true,
        canDownload: perms.downloadFile ?? true,
    }));

    return body;
}

const buildFilesPayload = ({
    isChecked,
    isCheckedAll,
    selectedIds,
    fileSelected,
    notSelectedFile,
    notFileSelected
}: {
    isChecked: boolean
    isCheckedAll: boolean
    selectedIds: number[]
    fileSelected: number[]
    notSelectedFile: number[]
    notFileSelected: number[]
}) => {
    if (!isCheckedAll) {
        return {
            allFiles: false,
            files: fileSelected
        }
    }

    if (!isChecked) {
        return {
            allFiles: false,
            files:
                notSelectedFile.length === 0
                    ? selectedIds
                    : selectedIds.filter(id => !notSelectedFile.includes(id))
        }
    }

    return {
        allFiles: true,
        files: Array.from(new Set([...notFileSelected, ...notSelectedFile]))
    }
}

const updatePermisisonBodyMassive = ({
    userPermissions,
    isChecked,
    isCheckedAll,
    selectedIds,
    fileSelected,
    notSelectedFile,
    notFileSelected
}: {
    userPermissions: Record<string, { seeFile?: boolean; downloadFile?: boolean; }>
    isChecked: boolean
    isCheckedAll: boolean
    selectedIds: number[]
    fileSelected: number[]
    notSelectedFile: number[]
    notFileSelected: number[]
}) => {

    const { allFiles, files } = buildFilesPayload({ fileSelected, isChecked, isCheckedAll, selectedIds, notSelectedFile, notFileSelected })

    const allBody = {
        allFiles: allFiles,
        ids: files,
        users: Object.entries(userPermissions).map(([id, perms]) => ({
            id: Number(id),
            canView: perms.seeFile ?? true,
            canDownload: perms.downloadFile ?? true,
        }))
    }

    return allBody;
}

const addFileBody = ({ isCheckedDownload, isCheckedSee, noSelectedDownload, noSelectedSee, selectedSee, userId, selectedDownload }: { selectedDownload: number[]; userId: number; isCheckedSee: boolean; selectedSee: number[]; noSelectedSee: number[]; isCheckedDownload: boolean; noSelectedDownload: number[]; }) => {

    let body: BodyAddFile;

    if (!isCheckedSee) {
        body = {
            userSharedId: userId,
            news: {
                newFiles: selectedSee.map((id) => ({
                    fileId: id,
                    canView: selectedSee.includes(id),
                    canDownload: selectedDownload.includes(id),
                })),
                allDownload: false,
                allView: false,
                noFileIds: [],
                noFileIdsDownload: [],
                canDownloadChanged: false
            }
        }
    } else {
        if (!isCheckedDownload) {
            body = {
                userSharedId: userId,
                news: {
                    newFiles: selectedDownload.map((id) => ({
                        fileId: id,
                        canView: true,
                        canDownload: selectedDownload.includes(id),
                    })),//
                    allDownload: false,
                    allView: true,
                    noFileIds: noSelectedSee,
                    noFileIdsDownload: [],
                    canDownloadChanged: false
                }
            }
        } else {
            body = {
                userSharedId: userId,
                news: {
                    newFiles: [],
                    allDownload: true,
                    allView: true,
                    noFileIds: noSelectedSee,
                    noFileIdsDownload: noSelectedDownload,
                    canDownloadChanged: false
                }
            }
        }
    }



    return body;
}

const addUserFilesBody = ({ isCheckedDownload, isCheckedSee, noSelectedDownload, noSelectedSee, selectedSee, userId, selectedDownload, arrayEdits, flagCheckedDownload, flagCheckedSee }: { flagCheckedDownload: boolean; flagCheckedSee: boolean; arrayEdits: { idFile: number; seeFile?: boolean | undefined; downloadFile?: boolean | undefined; }[]; selectedDownload: number[]; userId: number; isCheckedSee: boolean; selectedSee: number[]; noSelectedSee: number[]; isCheckedDownload: boolean; noSelectedDownload: number[]; }) => {

    let body: BodyAddFile;

    if (!flagCheckedDownload && !flagCheckedSee) {
        //se edito de a uno por uno
        body = {
            userSharedId: userId,
            news: {
                newFiles: arrayEdits.map((editFile) => ({
                    fileId: editFile.idFile,
                    canView: !!editFile.seeFile,
                    canDownload: !!editFile.downloadFile,
                })),
                allDownload: false,
                allView: false,
                noFileIds: [],
                noFileIdsDownload: [],
                canDownloadChanged: flagCheckedDownload,
            }
        }
    } else {
        if (!flagCheckedDownload) {

            //no se editaron todos los donwload
            if (!arrayEdits.length) {
                //solo se edito seefiles
                if (isCheckedSee) {
                    //se editaron todos los seefiles y ninguno de donwload
                    body = {
                        userSharedId: userId,
                        news: {
                            newFiles: [],
                            allDownload: false,
                            allView: true,
                            noFileIds: noSelectedSee,
                            noFileIdsDownload: [],
                            canDownloadChanged: flagCheckedDownload,
                        }
                    }
                } else {
                    //se editaron algunos seefiles y ninguno de download
                    body = {
                        userSharedId: userId,
                        news: {
                            newFiles: selectedSee.map((id) => ({
                                fileId: id,
                                canView: selectedSee.includes(id),
                                canDownload: selectedDownload.includes(id),
                            })),
                            allDownload: false,
                            allView: false,
                            noFileIds: [],
                            noFileIdsDownload: [],
                            canDownloadChanged: flagCheckedDownload,
                        }
                    }
                }
            } else {
                //se editó seefiles y algunos de donload
                if (isCheckedSee) {
                    //se editaron todos los seefiles y algunos de donload
                    body = {
                        userSharedId: userId,
                        news: {
                            newFiles: arrayEdits.map((file) => ({
                                fileId: file.idFile,
                                canView: !!file.seeFile,
                                canDownload: !!file.downloadFile,
                            })),
                            allDownload: false,
                            allView: true,
                            noFileIds: noSelectedSee,
                            noFileIdsDownload: [],
                            canDownloadChanged: flagCheckedDownload,
                        }
                    }
                } else {
                    //se editaron algunos seefiles y algunos de donload
                    body = {
                        userSharedId: userId,
                        news: {
                            newFiles: selectedSee.map((id) => ({
                                fileId: id,
                                canView: selectedSee.includes(id),
                                canDownload: !!arrayEdits.find(item => item.idFile == id)?.downloadFile
                            })),
                            allDownload: false,
                            allView: false,
                            noFileIds: [],
                            noFileIdsDownload: [],
                            canDownloadChanged: flagCheckedDownload,
                        }
                    }
                }
            }
        } else {
            //se editaron ambos
            if (!isCheckedSee) {
                body = {
                    userSharedId: userId,
                    news: {
                        newFiles: selectedSee.map((id) => ({
                            fileId: id,
                            canView: selectedSee.includes(id),
                            canDownload: selectedDownload.includes(id),
                        })),
                        allDownload: false,
                        allView: false,
                        noFileIds: [],
                        noFileIdsDownload: [],
                        canDownloadChanged: flagCheckedDownload,
                    }
                }
            } else {
                if (!isCheckedDownload) {
                    body = {
                        userSharedId: userId,
                        news: {
                            newFiles: selectedDownload.map((id) => ({
                                fileId: id,
                                canView: true,
                                canDownload: selectedDownload.includes(id),
                            })),//
                            allDownload: false,
                            allView: true,
                            noFileIds: noSelectedSee,
                            noFileIdsDownload: [],
                            canDownloadChanged: flagCheckedDownload,
                        }
                    }
                } else {
                    body = {
                        userSharedId: userId,
                        news: {
                            newFiles: [],
                            allDownload: true,
                            allView: true,
                            noFileIds: noSelectedSee,
                            noFileIdsDownload: noSelectedDownload,
                            canDownloadChanged: flagCheckedDownload,
                        }
                    }
                }
            }
        }
    }

    return body;
}

const deleteFilesBody = ({ userId, deleteSelected, isChecked, noDeleteSelected }: { userId: number; isChecked: boolean; deleteSelected: number[]; noDeleteSelected: number[]; }) => {

    let body: BodyAddFile;

    if (!isChecked) {
        body = {
            userSharedId: userId,
            deleteFiles: {
                all: false,
                filesIds: deleteSelected,
                noFileIds: [],
            }
        }
    } else {
        body = {
            userSharedId: userId,
            deleteFiles: {
                all: true,
                filesIds: [],
                noFileIds: noDeleteSelected,
            }
        }
    }

    return body;
}

export { updatePermisisonBody, createFileBody, addFileBody, deleteFilesBody, addUserFilesBody, updateFileBody, updatePermisisonBodyMassive }